import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import SuggestionBox from "../../../common/suggestionBox/SuggestionBox";
import Summary from "../../../components/yourAssets/BOA/bankBalance/Summary";
import { visited } from "../../../redux/slices/features/assetsOnBoardingSlice";

const BankBalances = ({ next, back, tabText }) => {
  const [showDetails, setShowDetails] = useState(false);
  const updates = useSelector((state) => state.auditTrail.updates);

  return (
    <>
      <Summary next={next} back={back} updates={updates} />
      <SuggestionBox
        mainText={tabText}
        tabName="BankBalances"
        next={showDetails}
        click={() => {
          setShowDetails(!showDetails);
        }}
        setVisited={visited}
      />
    </>
  );
};

export default BankBalances;
